export function validateJson(value) {
  const trimmed = (value || "").trim()

  if (trimmed === "") {
    return { valid: true, empty: true, message: "Empty (will be null)" }
  }

  try {
    JSON.parse(trimmed)
    return { valid: true, empty: false, message: "Valid JSON" }
  } catch (error) {
    return { valid: false, empty: false, message: `Invalid JSON: ${error.message}` }
  }
}

export function formatJson(value) {
  const trimmed = (value || "").trim()
  if (!trimmed) return ""

  const parsed = JSON.parse(trimmed)
  return JSON.stringify(parsed, null, 2)
}

export function displayFieldValue(value) {
  if (value == null) return ""
  if (typeof value === "object") return JSON.stringify(value, null, 2)
  return String(value)
}
